import { FelaCSS } from '../../components/fela/flowtypes';
import { IStylingProps } from '../../themes/types';
import { TColor } from '../../types';
import IconWrap from './icon-wrap';

interface IProps extends IStylingProps {
  id?: string;
  color?: TColor;
  width?: number;
  style?: FelaCSS;
}

interface IconTypes {
  iconColor: string;
  width: number;
  height: number;
}

const IconWeddingLicence = ({ id, color, width = 18, style, ...restProps }: IProps) => {
  const viewBoxWidth = 18;
  const viewBoxHeight = 17;

  const icon = ({ iconColor, width, height }: IconTypes) => (
    <svg
      id={id}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      width={`${width}px`}
      height={`${height}px`}>
      <path
        fill={iconColor}
        d="M17.8 6.5L12.2.3c-.1-.2-.3-.3-.5-.3s-.4.1-.5.3l-.6.8c-.5.7-1 1.5-1.5 2.2h-.2L4.3 5c-.2.1-.4.2-.4.4L0 16c-.1.2 0 .5.1.7.2.2.4.3.7.2l11-2.7c.2 0 .3-.2.4-.3l2.2-4.5v-.1l3.3-1.8c.2-.1.3-.3.3-.5s0-.4-.2-.5zM11.1 13L3 15l3.2-2.9c.9.6 2.1.6 3-.2 1-.9 1.1-2.5.1-3.5s-2.4-1.1-3.4-.2c-.8.7-1 2-.5 2.9L2.2 14 5 6.2l4-1.5 4 4.5-1.9 3.8zM6.8 9.2c.5-.4 1.2-.4 1.6.1.4.5.4 1.2-.1 1.6-.5.4-1.2.4-1.6-.1-.4-.5-.4-1.2.1-1.6zm7-1.1l-3.6-4c.5-.7 1-1.5 1.6-2.2l.1-.1 4.5 5-2.6 1.3z"
      />
    </svg>
  );

  return (
    <IconWrap
      icon={icon}
      color={color}
      width={width}
      viewBoxWidth={viewBoxWidth}
      viewBoxHeight={viewBoxHeight}
      style={style}
      {...restProps}
    />
  );
};

export default IconWeddingLicence;
